import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findUserLoginSession = (
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
    };
    fetchPost(
        uri + "/admin/session",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};
